import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControl from 'Components/UI/Meta/MetaControl';
import ErrorList from 'Components/UI/ErrorList';
import Typography from 'Components/UI/Typography';
import useMetaFormBuilder from 'Hooks/useMetaFormBuilder';
import { FlowStepQuestionOverride } from 'Overrides/Flow';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  question: {
    paddingBottom: theme.spacing(2),
  },
  description: {
    paddingBottom: theme.spacing(2),
  },
});

const FlowStepQuestion = ({
  className,
  classes,
  questionResource,
}) => {
  const {
    eventTrackingNodeRef,
    errors,
    resource,
    onChange,
  } = useMetaFormBuilder({
    autoSave: true,
    resource: questionResource,
    useResourceArgs: {
      metaOverrideSet: FlowStepQuestionOverride,
    },
  });

  const description = questionResource.attr('description') || '';
  const isDescriptionAboveQuestion = !resource.meta().field('response').attr('_flowDescriptionBelowQuestion');

  return (
    <div
      className={classNames(classes.root, className)}
      ref={eventTrackingNodeRef}
    >
      <Typography
        className={classes.question}
        color="white"
        variant="h3"
      >
        {questionResource.attr('question')}
      </Typography>
      {(description.length > 0 && isDescriptionAboveQuestion) ? (
        <Typography
          className={classes.description}
          color="white"
          variant="h5"
        >
          {questionResource.attr('description')}
        </Typography>
      ) : null}
      <MetaControl
        resource={resource}
        attrName="response"
        onChange={(attrValue) => {
          onChange('response', attrValue);
        }}
      />
      {(description.length > 0 && !isDescriptionAboveQuestion) ? (
        <Typography
          className={classes.description}
          color="white"
          variant="h5"
        >
          {questionResource.attr('description')}
        </Typography>
      ) : null}
      <ErrorList
        className={classes.errorList}
        errors={errors}
        hideErrorTitle
        title={null}
      />
    </div>
  );
};

FlowStepQuestion.defaultProps = {
  className: '',
};

FlowStepQuestion.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  questionResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(FlowStepQuestion);
